import { MetaDataInfo } from 'components';
import { FieldArray, Form, Formik } from 'formik';
import * as React from 'react';
import styled from '../../../../config/theme';
import { UseMetaDataActions } from '../../../../types/metadata';
import { fullProductSchema } from '../../schema/productBaseEditSchema';
import { ProductBaseFormValues } from '../../types/product';
import { DescriptionInfo, GeneralInfo } from './';
import PartnerCenterInfo from './PartnerCenterInfo';
import PricingProfileInfo from './PricingProfileInfo';

type Props = {
  formRef: React.RefObject<any>;
  handleFormChange: () => void;
  handleSubmit: (values: ProductBaseFormValues) => void;
  metaDataActions?: UseMetaDataActions;
  newProduct?: boolean;
  product: ProductBaseFormValues;
};

const ProductBaseForm: React.FC<Props> = ({ formRef, handleFormChange, handleSubmit, metaDataActions, product }) => {
  return (
    <Formik
      initialValues={{
        ...product,
      }}
      onSubmit={(values: ProductBaseFormValues) => {
        handleSubmit(values);
      }}
      innerRef={formRef}
      validationSchema={fullProductSchema}
      validate={handleFormChange}
      validateOnChange={false}
      render={({ errors, touched, values }) => {
        return (
          <FormWrapper>
            <Form>
              <GeneralInfo touched={touched} errors={errors} />
              <DescriptionInfo translations={values.translations} touched={touched} errors={errors} />
              <PricingProfileInfo touched={touched} errors={errors} />
              <PartnerCenterInfo
                touched={touched}
                errors={errors}
                partnerCenterProfile={product.partnerCenterProfile}
              />

              <FieldArray
                name="metadatas"
                render={() => (
                  <MetaDataInfo
                    amountOfButtons={1}
                    errors={errors}
                    metaDatas={values.metadatas.map((item) => {
                      return { ...item, metadataId: item.metadataId, code: '', accessibility: 'editable' };
                    })}
                    metaDataActions={metaDataActions}
                  />
                )}
              />
            </Form>
          </FormWrapper>
        );
      }}
    />
  );
};

const FormWrapper = styled.div`
  padding-top: 25px;
`;

export default ProductBaseForm;
